import * as yup from 'yup'
import { ImportBranchDto } from './importBranchDto'

export class PortOfLadingDto {
  portOfLadingGuid?: string = undefined
  cityProvince?: string = undefined
  isActive?: boolean = undefined
  importBranches?: ImportBranchDto[] = []
}

export const portOfLadingValidationSchema = yup.object({
  id: yup.string().nullable(),
  cityProvince: yup
    .string()
    .max(200, 'Port of Lading cannot be more than 200 characters.')
    .required('Port of Lading is required.'),
  isActive: yup.boolean()
})
